import { render } from "./SJinventory.vue?vue&type=template&id=aa9aedd8&scoped=true"
import script from "./SJinventory.vue?vue&type=script&lang=js"
export * from "./SJinventory.vue?vue&type=script&lang=js"

import "./SJinventory.vue?vue&type=style&index=0&id=aa9aedd8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aa9aedd8"

export default script